document.addEventListener('DOMContentLoaded', function () {
    const cartButtons = document?.querySelectorAll('.btn.btn--full.add-to-cart.btn--secondary');
    
    cartButtons.forEach(button => {
        button.addEventListener('click', function () {
            const boldButtons = document?.querySelectorAll('.btn.btn--full.add-to-cart.btn--secondary.bold_clone');
            let boldBtnText = boldButtons[0]?.querySelector('.add-to-cart-text--container')?.classList;
            let boldBtnSpinner = boldButtons[0]?.querySelector('.loading-icon')?.classList;
            if (boldButtons && boldButtons.length > 0) {
                boldBtnText.value = 'add-to-cart-text--container hidden';
                boldBtnSpinner.value = 'loading-icon';
            }
        })
    })
    
    setTimeout(() => {
        const boldButtons = document?.querySelectorAll('.btn.btn--full.add-to-cart.btn--secondary.bold_clone');
        boldButtons.forEach(boldButton => {
            boldButton.addEventListener('click', function () {
                boldButton.classList.add('loading');
            })
        })
    }, 100);
});